import { FilterDateRange, GlobalFilterOptions, UUID } from '@ot/shared/model';
import { Label } from './label';

export enum VehicleType {
  Unknown = 'Unknown',
  Tractor = 'Tractor',
  Truck = 'Truck'
}

export class BaseVehicle {
  customId: string;
  name: string;
  vin: string;
  useManuallyEnteredVin: boolean;
  licensePlate: string;
  licensePlateState: string;
  country: string;
  state: string;
  odometer: number;
  odometerReadDate: string;
  odometerReadTime?: string;
  engineHours: number;
  ownerOperator: boolean;
  iftaVehicle: string;
  iftaReportable: boolean;
  hosExempt: string;
  eldVehicle: string;
  manufacturer: string;
  yearBuilt: number;
  model: string;
  manufacturingDate: string;
  manufacturingTime?: string;
  transmissionManufacturer: string;
  transmissionType: string;
  horsepower: number;
  vehicleAxles: number;
  unladenGrossVehicleWeight: number;
  fuelDrawCapacity: number;
  auxiliary: string;
  hasElectronicEngine: boolean;
  hasBerth: boolean;
  leased: boolean;
  updatedDate: string;
  startDate: string;
  startTime: string;
  terminationDate: string;
  terminationTime: string;
  ownerOperatorName: string;
  registeredLadenGrossVehicleWeight: number;
  labels: Label[];
}

export class Vehicle extends BaseVehicle {
  id: string;
  businessAccountId: string;
  status: string;
  vehicleType: VehicleType;
}

export class APIVehicle extends BaseVehicle {
  id: { value: string };
  businessAccountId: { value: string };
  status: { vehicleStatus: string };
  vehicleType: { vehicleType: VehicleType };
  labels: VehicleLabel[];
}

export interface VehicleLabels {
  id: string;
  customId: string;
  labels: Label[];
}

export class ListVehiclesResponse {
  vehicles: APIVehicle[];
  totalCount: string;
  totalPages: string;
  nextPageToken: string;
}

export class VehicleLabel {
  key: string;
  value: string;
}
export interface ApplyVehicleLabelsRequest {
  generalFilter: GlobalFilterOptions;
  vehicleFilter: VehicleFilter;
  labels: Label[];
}

export interface ApplyVehicleLabelsResponse {
  updatedVehicles: APIVehicle[];
}

export interface RemoveVehicleLabelsRequest {
  generalFilter: GlobalFilterOptions;
  vehicleFilter: VehicleFilter;
  labels: Label[];
}

export interface RemoveVehicleLabelsResponse {
  updatedVehicles: APIVehicle[];
}

export type VehicleLabelsOperationRequest =
  | ApplyVehicleLabelsRequest
  | RemoveVehicleLabelsRequest;

export type VehicleLabelsOperationResponse =
  | ApplyVehicleLabelsResponse
  | RemoveVehicleLabelsResponse;

export interface VehicleFilter {
  global?: GlobalFilterOptions;
  odometerReadDateRange?: FilterDateRange;
  manufacturingDateRange?: FilterDateRange;
  updateDateRange?: FilterDateRange;
  vehicleIds?: UUID[];
  customVehicleIds?: string[];
  vehicleType?: VehicleType;
  licensePlateJurisdiction?: string;
  labels?: Label[];
}
